import React, { useMemo, useEffect } from 'react';
import styled, { css } from 'styled-components';
import AudioPlay from './AudioPlay';
import { useAudios } from '../hooks/useAudios';

const LessonDataAudioList = ({ seed, freeze = false, onChange = () => {}}) => {
  const extractedAudios = useMemo(() => seed.map((i) => i.audio), [seed]);
  const audios = useAudios(extractedAudios);

  useEffect(() => {
    onChange({
      ready: true,
      data: seed,
    });
  }, [seed, onChange]);

  const isLoaded = ({ audio }) => (audio && audios[audio]) || !audio;

  return (
    <Container freeze={freeze}>
      {seed.map((item, index) => (
        <Row key={index}>
          {isLoaded(item) ? (
            <>
              <Text>{item.text}</Text>
              {item.audio && <AudioPlay audio={audios[item.audio]} />}
            </>
          ) : (
            <Spinner src='loading.gif' />
          )}
        </Row>
      ))}
    </Container>
  );
};


const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 20px;
  overflow: hidden;
  background-color: white;
  ${(props) =>
    props.freeze &&
    css`
      pointer-events: none;
    `}
`;

const Row = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  padding: 5px 15px;
  :nth-child(2n) {
    background-color: #fafafa;
  }
  & > * {
    margin: 5px;
  }
`;

const Text = styled.div`
  font-size: 0.9em;
  color: black;
`;

const Spinner = styled.img`
  margin: auto;
  width: 25px;
  height: 25px;
  display: block;
`;

export default LessonDataAudioList;
